
import BaseModel from '../base/base.model';

class ProfileStats extends BaseModel {

  constructor({
    id,
    name,
    activeAds,
    views,
    viewsByMonth,
    fill,
    messages,
    prints,
    rating,
    favorites
  }) {
    super({ id });

    this.activeAds = activeAds;
    this.views = views;
    this.viewsByMonth = viewsByMonth;
    this.fill = fill;
    this.name = name;
    this.messages = messages;
    this.prints = prints;
    this.rating = rating;
    this.favorites = favorites;
  }
}

export default ProfileStats;
